<div class="layout">
  <div class="layout-erreur">
    <div class="conteneur-erreur wrapper">
      <img
        id="unavailable"
        src="{{ 'assets/images/caisse-non-eligible.svg' | cheminAbsoluStatique }}"
        alt=""
        class="image"
      />
      <div class="conteneur-erreur-textPart">
        <h1 class="erreur-titre dsd-t-1">{{ 'caisse-non-eligible.erreur.libelle' | translate }}</h1>
        <div class="erreur-texte">
          <span class="error-explanation" [innerHTML]="'caisse-non-eligible.erreur.ligne-1' | translate"></span>
          <span
            class="error-explanation"
            [innerHTML]="'caisse-non-eligible.erreur.ligne-2' | translate: { link: link }"
          ></span>
        </div>
      </div>
    </div>

    <div class="page-footer wrapper">
      <button mat-button class="action-precedent" id="action-precedent" (click)="retourAccueil()">
        <img
          src="{{ 'assets/images/fleche-verte.svg' | cheminAbsoluStatique }}"
          alt=""
          width="6"
          height="12"
          class="chevron"
        />
        {{ 'caisse-non-eligible.erreur.retour' | translate }}
      </button>
    </div>
  </div>
</div>
